import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, LabelL } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';

const Root = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--double-unit);
`;

type Props = {
  open?: boolean;
  onClose: () => void;
};

export const PackSoldOutDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      title={
        <LabelL bold>
          <FormattedMessage defaultMessage="Too late!" />
        </LabelL>
      }
    >
      <Root>
        <BodyM color="var(--c-nd-600)">
          <FormattedMessage defaultMessage="No packs left for now, but don’t worry — more are coming soon." />
        </BodyM>
        <Button size="medium" color="quaternary" onClick={onClose} fullWidth>
          <FormattedMessage defaultMessage="Try again later" />
        </Button>
      </Root>
    </Dialog>
  );
};
